import script from "./MsgBoxComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MsgBoxComponent.vue?vue&type=script&setup=true&lang=js"

import "./MsgBoxComponent.vue?vue&type=style&index=0&id=61c80dc2&lang=css"

const __exports__ = script;

export default __exports__